import React from 'react';
import Classes from 'classnames';
import FieldTimeReported from "../../../time-spent";

type Props = {
    onSubmit?: callback,
    field       : FieldTimeReported
}

export default function MinutesPreset(props:Props) {

    if (!props.field.presetMinutes) return null

    const onValueChange = (value: number) => {
        // app.model.reportedTimeMinutes = value
        props.onSubmit && props.onSubmit(value)
        // app.onSubmitReport()
    }
    return (
        <div className="m-t-10 flex-column-left-top">
            <div className="ui5-txt-no-accent-tiny">Minutes</div>
            <div className="flex-row-left-center m-t-10">
                {props.field.presetMinutes.map((obj, key)=>{
                    const classes = Classes("ui5-popover-preset-value",{
                        selected: false //(app.model.reportedTimeMinutes === obj.value)
                    });
                    return (
                        <div key={key} className={classes} onClick={()=>onValueChange(obj.value as number)}>{obj.label}</div>
                    )
                })}
            </div>
        </div>
    );


}



